import { useCallback } from 'react'

import { useTranslation } from 'react-i18next'

import { CancelWarningExely } from 'entities/kyrgyzstan'

import { CancellationPolicy } from 'shared/api/kyrgyzstan/search/model'
import { getRawColor } from 'shared/lib/getRawColor'
import { AllIcons } from 'shared/ui/app-icon/types'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { InfoItem } from 'shared/ui/info-item'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface ExelyCancellationSectionProps {
  cancellationPolicy?: CancellationPolicy | null
}

export const ExelyCancellationSection = ({
  cancellationPolicy,
}: ExelyCancellationSectionProps) => {
  const { t } = useTranslation()
  const { openDialog } = useDialogBottomSheet()

  const handleOpenCancellationPolicy = useCallback(() => {
    openDialog({
      child: <CancelWarningExely cancellationPolicy={cancellationPolicy} />,
      backgroundColor: getRawColor('--white'),
    })
  }, [cancellationPolicy, openDialog])

  if (!cancellationPolicy) {
    return null
  }

  return (
    <Paper
      padding={[0]}
      radius="16"
    >
      <InfoItem
        className={s.infoItem}
        title={t('kyrgyzstan_block.policy.title_two')}
        subtitle={t('kyrgyzstan_block.policy.subtitle_two')}
        icon={AllIcons.CANCEL_MONEY}
        onClick={handleOpenCancellationPolicy}
      />
    </Paper>
  )
}
